/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FormItem } from '../models/form-item';
import { NewFormItem } from '../models/new-form-item';

@Injectable({
  providedIn: 'root',
})
export class FormItemControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation formItemControllerUpdateByFormid
   */
  static readonly FormItemControllerUpdateByFormidPath = '/form-items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateByFormid()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateByFormid$Response(params: {
    formid: string;
    context?: HttpContext
    body?: NewFormItem
  }
): Observable<StrictHttpResponse<FormItem>> {

    const rb = new RequestBuilder(this.rootUrl, FormItemControllerService.FormItemControllerUpdateByFormidPath, 'post');
    if (params) {
      rb.path('formid', params.formid, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormItem>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateByFormid$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateByFormid(params: {
    formid: string;
    context?: HttpContext
    body?: NewFormItem
  }
): Observable<FormItem> {

    return this.updateByFormid$Response(params).pipe(
      map((r: StrictHttpResponse<FormItem>) => r.body as FormItem)
    );
  }

}
